import { ConvertedComponentData } from '../../types'
import { inject } from '@angular/core'
import { WindowRef } from '@spartacus/core'
import { Observable } from 'rxjs'

export const createCypressInitialize = <T extends ConvertedComponentData | null>(winRef = inject(WindowRef)) =>
  (data$: Observable<T>) => data$.subscribe(data => {
    if (!winRef?.isBrowser() || !winRef.nativeWindow?.Cypress || !data?.flexType) {
      return
    }

    let isPresent = false
    let i = 0
    let name = data?.flexType as any
    while (!!winRef.nativeWindow[name]) {
      name = data?.flexType + `_${++i}`
    }
    for (let index = 0; index < i; index++) {
      const n = data?.flexType as string + ((index === 0) ? '' : `_${index}`) as any
      if ((winRef.nativeWindow[n] as any)?.uid === data?.uid) {
        isPresent = true
      }
    }
    if (!isPresent) {
      (this as any).uid = data.uid
      winRef.nativeWindow[name] = this as any
      const previewId = data?.previewId as any ?? ''
      winRef.nativeWindow[previewId] = data.source
    }
  })
